import { lazy, LazyExoticComponent, Suspense } from "react";

import { Brand } from "../../../store/slices/environmentSlice";
import { useTypedSelector } from "../../../store/store";
import LoadingContainer from "../../containers/LoadingContainer";

const DefaultSignIn = lazy(() => import("./default"));
const VidSignIn = lazy(() => import("./vid"));

const PAGES_BY_BRAND: Record<
  Brand,
  LazyExoticComponent<
    ({ isMenuVisible, onMenuToggle }: IRootHeaderProps) => JSX.Element
  >
> = {
  default: DefaultSignIn,
  vid: VidSignIn,
  dtw: DefaultSignIn,
  aov: DefaultSignIn,
  cen: DefaultSignIn,
};

interface IRootHeaderProps {
  isMenuVisible: boolean;
  onMenuToggle: () => void;
}

function RootHeader({ isMenuVisible, onMenuToggle }: IRootHeaderProps) {
  const { brand } = useTypedSelector((state) => state.environment);

  const PageByBrand = PAGES_BY_BRAND[brand] ?? DefaultSignIn;

  return (
    <Suspense
      fallback={
        <LoadingContainer isLoading>
          <></>
        </LoadingContainer>
      }>
      <PageByBrand isMenuVisible={isMenuVisible} onMenuToggle={onMenuToggle} />
    </Suspense>
  );
}

export default RootHeader;
